import { render, staticRenderFns } from "./GroupRoleUserCreate.vue?vue&type=template&id=5b57f8c9&"
import script from "./GroupRoleUserCreate.vue?vue&type=script&lang=js&"
export * from "./GroupRoleUserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports